// supabase.js — Supabase-klient for Tindre
// ─────────────────────────────────────────────────────────────────────────────
// Trygg init: feilar oppsettet (manglande/feil nøklar), skal det IKKJE krasje
// appen. supabaseKlar() seier om klienten finst. Økta lagrast i IndexedDB
// (supabase-js default) — fungerer i iOS PWA standalone.
// ─────────────────────────────────────────────────────────────────────────────
import { createClient } from "@supabase/supabase-js";

// BERR base-URL — IKKJE med /rest/v1/ (supabase-js legg det på sjølv)
const SUPABASE_URL = "https://lvzhsebsmxjtbpehsblv.supabase.co";
const SUPABASE_ANON = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx2emhzZWJzbXhqdGJwZWhzYmx2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIyMzM5OTksImV4cCI6MjA5NzgwOTk5OX0.rrMxXPP2UWZocQBE3FLTFCxVecWMdZXkN9c3U0g8OJ0";

let _klient = null;
try {
  if (SUPABASE_URL && SUPABASE_ANON) {
    _klient = createClient(SUPABASE_URL, SUPABASE_ANON, {
      auth: {
        persistSession: true,      // hald økta mellom oppstartar
        autoRefreshToken: true,    // forny token automatisk
        detectSessionInUrl: false, // ingen magic-link-redirect (vi brukar passord)
      },
    });
  }
} catch (e) {
  // Svelg feil — appen skal fungere (utforskande modus) sjølv utan backend
  _klient = null;
}

export const supabase = _klient;
export function supabaseKlar() {
  return _klient !== null;
}
